/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:20
 * @LastEditTime: 2019-10-22 17:18:55
 * @LastEditors: Please set LastEditors
 */
import axios from "axios";
import qs from "qs";
axios.defaults.timeout = 500000;
axios.defaults.withCredentials = true;
//http request 拦截器

axios.interceptors.request.use(
  (config) => {
    config.data = qs.stringify(config.data);
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      accept: "application/json",
    };
    if (process.env.VUE_APP_type == "development") {
      localStorage.setItem(
        "access_tokens",
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijc0OWUxNDY0NzM4ZWU0MWY2ZGMzYjkxYTU2YmRkZGQyMDcyNDUwZTZmZTY1ZGJkNTU2MWE1ZjU2MWEyOTgzM2FiODczNDJmODA3MTk3NmZlIn0.eyJhdWQiOiIxMDA4ODAwMyIsImp0aSI6Ijc0OWUxNDY0NzM4ZWU0MWY2ZGMzYjkxYTU2YmRkZGQyMDcyNDUwZTZmZTY1ZGJkNTU2MWE1ZjU2MWEyOTgzM2FiODczNDJmODA3MTk3NmZlIiwiaWF0IjoxNzgyMDk5NDYwLCJuYmYiOjE3ODIwOTk0NjAsImV4cCI6MTc4MzM5NTQ2MCwic3ViIjoiMTI0Iiwic2NvcGVzIjpbIioiXX0.pdUnQjOv6YydAYNc2G4qTgb0uXvTyB4CLwlPhRUp98fIsnWf_gzJwktrrwzzKkyyeowe7R4f4Td4w7jg47Mbo-DHcwTKlaSFCO7QgaIArtPVZ3zZvq3c22DHa4tkalofXFB23EQz1-bG1Oja3WGEBA5lW7R4QKwvDI-Mk0r6Zl_R2ru514YcgeHRW2RMGWr1elRLw2WmEfJQVxhw6OWAEjEc_emlZ0aQPxYumEqe8CPP14Wr9qI-u3QUovS7QNXVBMfHYm-I4_OPGFTjoiTHpICFB78FXaBIgQgMWHSy7O3fXVAJAOzZ652iHdhrl_H3IXaIQY57uklvePqbh_5faiH90lVnPwVtkQ8HRWaJGshLwIX5jLa2qoTTGzfbRkwSjSbFNtgieSB8pWV_8LyCdw9PdU9nt9S60MNu15-TQFM6D8qenay6a1E7W_TfbTBiPbbZgmvD0l44iyUvta-UNjnpnGpIOD7P_Rdg20tn6H6u0SOEUG1MqprGpSFyJ0MfwiKkEm-QRDqlTIFYtW768ZqTsmPyXAPO-y7262a7la09T0ZqmxsqUCJQ1ABGehC8fDGJ5MV1ZkWfVyEb2yT3mht_Vl6eV1yIgLuVCJbzuoE9DhcHYHlv1GDjuY8PfcbOEbwElhyLXSBzDR8KSoVLYSvA1K650VHvqpupU3cmkMc"
      );
    }
    config.headers.Authorization =
      "Bearer" + " " + localStorage.getItem("access_tokens");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//http response 拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data.code == 100) {
      location.href = location.href.split("#/")[0] + "#/login"; //跳回登陆页面
    }
    return response;
  },
  (error) => {
    if (error.data) {
      return Promise.reject(error.data);
    } else {
      return Promise.reject(error.response.data);
    }
  }
);

//定义全局的api
let api;

if (process.env.VUE_APP_type == "development") {
  api = {
    logistics: "http://znwl.com/admin/v2",
    logistics_2: "http://pps.qwe.com/index.php/",
    pda: "http://znwl.com/pda/v2/",
  };
  api = {
    logistics: "https://logistics.tx315.vip/admin/v2",
    // logistics: "http://znwl.com/admin/v2",
    logistics_2: "https://pps.tx315.vip/index.php/",
    pda: "https://logistics.tx315.vip/pda/v2/",
    // pda: "http://znwl.com/pda/v2/",
  };
} else if (process.env.VUE_APP_type == "production") {
  api = {
    logistics: "https://logistics.tx315.vip/admin/v2",
    logistics_2: "https://pps.tx315.vip/index.php/",
    pda: "https://logistics.tx315.vip/pda/v2/",
  };
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch (module, url, params = {}) {
  let baseUrl = "";
  if (module == "logistics") {
    baseUrl = api.logistics + url;
  } else if (module == "logistics_2") {
    baseUrl = api.logistics_2 + url;
  } else if (module == "pda") {
    baseUrl = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post (module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch (module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put (module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del (module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
